/**
 * @file 現在地取得
 */
'use strict';


/**
 * @classname AdjustMap
 * @classdesc 地図位置調整
 */
export default class AdjustMap {
	/**
	 * @constructor
	 * @param {object} controller - controller オブジェクト
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('AdjustMap.constructor');
		this._$e = $e;
		const lat = parseFloat($('#lat').val());
        const lng = parseFloat($('#lng').val());
        const name = $('#name .form-control-static').text();
        console.log(lat, lng);
        this._LatLng = new google.maps.LatLng({lat: lat, lng: lng});
        console.log(this._LatLng);
        const  mapOption = {
            center: this._LatLng,
            zoom: 19,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: true,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false
        }
        const map = new google.maps.Map(document.getElementById('adjustMap'), mapOption);
        this._map= map;
        this._marker = new google.maps.Marker({
            position: this._LatLng,
            map,
            title: name
        });
        this._map.addListener('center_changed', () => {
            setTimeout(()=> {
                this.centerChanged()
            },1000);
        });
    };


	/**
	 * 中心変更
	 *
	 * @memberof AdjustMap
	 * @return {undefined}
	 */
    centerChanged() {
		console.log('AdjustMap.centerChanged');
		const latlng = this._map.getCenter();
		const lat = latlng.lat();
		const lng = latlng.lng();
        this._marker.setPosition(latlng);
        $('#lat').val(lat);
        $('#lng').val(lng);
	};
}
